import { axiosCentral, throwResponse } from "config/axios";
import {
  IDashboardGraph,
  IDashboardParams,
  IDashboardTitle,
  IResponseDashboardCentral,
} from "../../interface";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

export const useGetDashboardNewsCountMostReader = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IDashboardTitle[]>[], Error> => {
  return useQuery(
    ["dashboard-news", "count-most-reader", params],
    async () => {
      const res = await axiosCentral.get(
        "/dashboard/news-announcement/count-most-reader",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};

export const useGetDashboardNewsCountPerMonth = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IDashboardGraph[]>[], Error> => {
  return useQuery(
    ["dashboard-news", "count-reader-per-month", params],
    async () => {
      const res = await axiosCentral.get(
        "/dashboard/news-announcement/count-reader-per-month",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
